import { Form } from "antd"
import { Checkbox, Text } from "components/common"
import { t } from "i18next"
import { mergePaymentsRowPatch } from "../utils/paymentUtils"

const RACheckbox = ({ listFieldName, fieldName = "enableRA", getAccountant, ...restField }) => {
  const form = Form.useFormInstance()

  return (
    <Form.Item {...restField} preserve name={[listFieldName, fieldName]} valuePropName="checked">
      <Checkbox
        onChange={e => {
          if (e?.target?.checked) {
            getAccountant(null, true)
            mergePaymentsRowPatch(form, listFieldName, {
              paymentProof: null,
              ocrData: null,
              buyerFee: false,
              ...(fieldName === "enableRA" ? { modeOfPayment: null } : {}),
            })
          }
        }}
      >
        <Text className="gray-900">{t("Cash Submitted by RA")}</Text>
      </Checkbox>
    </Form.Item>
  )
}

export default RACheckbox
